export const calculateDiscount = (rrp, price) => {
  const rrpAmount = Number(rrp) || 0
  const priceAmount = Number(price) || 0
  return (rrpAmount - priceAmount).toFixed(2)
}
